import * as requestFromServer from "./subscriptionsCrud";
import {subscriptionsSlice, callTypes} from "./subscriptionsSlice";

const {actions} = subscriptionsSlice;

export const fetchSubscriptions = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  const status = window.location.pathname.split("/")[2]
  if(status==="approved") { queryParams.filter.type=1; }
  if(status==="un-approved") { queryParams.filter.type=0; }
  //For all records
  if(!status)             {queryParams.filter.type=-1;}

  return requestFromServer
    .findSubscriptions(queryParams)
    .then(response => {
		const { totalCount, entities } = response.data
		dispatch(actions.subscriptionsFetched({totalCount, entities}));
    })
    .catch(error => {
      error.clientMessage = "Can't find subscriptions";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
}; 
